import { isTemporarySplitNode } from '../helpers/ivrHelpers';
import { getTimeRangeForTemporarySplitNode } from '../components/helpers/temporarySplitNodeHelpers';
import get from 'lodash/get';
import { MATCH_TEXT, ERROR_TEXT, NO_MATCH_TEXT, DEFAULT_TEXT } from '../components/ivrTree/helpers/nodesHelper';

export const NODE_CONNECTORS_DEFS = {
  IVR_NODE_SCHEDULE: [
    { field: 'defaultNextId', getOption: node => (isTemporarySplitNode(node.ivrNode.id) ? 'OFF' : NO_MATCH_TEXT) },
    {
      field: 'defaultOffId',
      getOption: () => 'ON',
      skipField: node =>
        !isTemporarySplitNode(node.ivrNode.id) ||
        getTimeRangeForTemporarySplitNode(get(node, 'ivrNode.nodeSchedules', [])).active,
    },
    {
      prefixPath: 'nodeSchedules',
      postfixPath: 'nodeId',
      getOption: node => (isTemporarySplitNode(node.ivrNode.id) ? 'ON' : MATCH_TEXT),
      skipField: node =>
        isTemporarySplitNode(node.ivrNode.id) &&
        !getTimeRangeForTemporarySplitNode(get(node, 'ivrNode.nodeSchedules', [])).active,
    },
  ],
  IVR_NODE_MENU: [
    { field: 'badSelectionNodeId', getOption: () => DEFAULT_TEXT },
    {
      prefixPath: 'menu',
      postfixPath: 'nextId',
      getOption: (_, option) => (option ? `Press ${option.dtmf}` : null),
    },
  ],
  IVR_NODE_MESSAGE: [{ field: 'nextId' }],
  IVR_NODE_VARIABLE_MATCH: [
    { field: 'defaultNextId', getOption: () => NO_MATCH_TEXT },
    { field: 'errorNodeId', getOption: () => ERROR_TEXT },
    {
      prefixPath: 'variableMatches',
      postfixPath: 'nextId',
      getOption: () => MATCH_TEXT,
    },
  ],
  IVR_NODE_VARIABLE: ['nextId', { field: 'errorNodeId', getOption: () => ERROR_TEXT }],
  IVR_NODE_INPUT: ['nextId'],
  IVR_NODE_SMS: ['nextId', { field: 'errorNodeId', getOption: () => ERROR_TEXT }],
  IVR_NODE_NUMBER_MATCH: [
    'defaultNextId',
    { prefixPath: 'numberMatchers', postfixPath: 'nextId', getOption: (_, option) => (option ? MATCH_TEXT : null) },
  ],
  IVR_NODE_HTTP: ['nextId', { field: 'errorNodeId', getOption: () => ERROR_TEXT }],
  IVR_NODE_HTTP2: ['nextId', { field: 'errorNodeId', getOption: () => ERROR_TEXT }],
  IVR_NODE_VOICE_AUTOMATION: [
    {
      field: 'closedNodeId',
      getOption: () => 'Resolved',
    },
    {
      field: 'handoffNodeId',
      getOption: () => 'Handoff',
    },
    {
      field: 'errorNodeId',
      getOption: () => ERROR_TEXT,
    },
  ],
};
